import { useState, useCallback } from 'react';

export function useBackgroundRemoval() {
  const [isRemoving, setIsRemoving] = useState(false);
  const [bgRemovalError, setBgRemovalError] = useState(null);

  const removeBg = useCallback(async (imageDataUrl) => {
    setIsRemoving(true);
    setBgRemovalError(null);
    try {
      const { removeBackground } = await import('@imgly/background-removal');
      const blob = await removeBackground(imageDataUrl, {
        model: 'medium',
        debug: false,
      });
      const blobUrl = URL.createObjectURL(blob);
      const toBase64 = new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
      return { blobUrl, toBase64 };
    } catch (err) {
      console.error('Background removal failed:', err);
      setBgRemovalError('Background removal failed. Please try again.');
      return null;
    } finally {
      setIsRemoving(false);
    }
  }, []);

  return { removeBg, isRemoving, bgRemovalError };
}
